import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import "./Registration.css";

const LOCAL_API_BASE_URL = "http://localhost:5000";
const RENDER_API_BASE_URL = "https://wecareehs-backend.onrender.com";
const API_BASE_URL = process.env.REACT_APP_USE_RENDER === "true" ? RENDER_API_BASE_URL : LOCAL_API_BASE_URL;

function Registration() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    phone: "",
    company: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          password: formData.password,
          phone: formData.phone,
          company: formData.company,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('token', data.token);
        navigate("/login");
      } else {
        setError(data.message || data.error || "Registration failed");
      }
    } catch (err) {
      setError("Registration failed. Please check your connection.");
    }

    setLoading(false);
  };

  return (
    <div className="split-login-container">
      {/* Left Visual Panel - Registration Variant */}
      <div className="visual-panel register-visual">
        <div className="visual-content">
          <h1 className="visual-heading">Join the<br />Evolution.</h1>
          <p className="visual-subtext">Create an account and start your journey.</p>
        </div>
        <div className="abstract-shape register-shape"></div>
        <div className="abstract-shape-2"></div>
      </div>

      {/* Right Form Panel */}
      <div className="form-panel">
        <div className="form-content register-content">
          <div className="brand-logo-area">
            <div className="logo-dot"></div>
          </div>

          <div className="login-header">
            <h2>Create Account</h2>
            <p>Fill in your details significantly.</p>
          </div>

          <form onSubmit={handleSubmit} className="split-form">

            <div className="form-row-split">
              <div className="minimal-input-group">
                <label>First Name</label>
                <input
                  type="text"
                  name="firstName"
                  className="minimal-input"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  placeholder="John"
                  required
                />
              </div>
              <div className="minimal-input-group">
                <label>Last Name</label>
                <input
                  type="text"
                  name="lastName"
                  className="minimal-input"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  placeholder="Doe"
                  required
                />
              </div>
            </div>

            <div className="minimal-input-group">
              <label>Email Address</label>
              <input
                type="email"
                name="email"
                className="minimal-input"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="john.doe@example.com"
                required
              />
            </div>

            <div className="form-row-split">
              <div className="minimal-input-group">
                <label>Password</label>
                <input
                  type="password"
                  name="password"
                  className="minimal-input"
                  value={formData.password}
                  onChange={handleInputChange}
                  placeholder="Create password"
                  required
                />
              </div>
              <div className="minimal-input-group">
                <label>Confirm</label>
                <input
                  type="password"
                  name="confirmPassword"
                  className="minimal-input"
                  value={formData.confirmPassword}
                  onChange={handleInputChange}
                  placeholder="Confirm password"
                  required
                />
              </div>
            </div>

            <div className="minimal-input-group">
              <label>Phone Number</label>
              <input
                type="tel"
                name="phone"
                className="minimal-input"
                value={formData.phone}
                onChange={handleInputChange}
                placeholder="+1 (555) 000-0000"
                required
              />
            </div>

            <div className="minimal-input-group">
              <label>Company (Optional)</label>
              <input
                type="text"
                name="company"
                className="minimal-input"
                value={formData.company}
                onChange={handleInputChange}
                placeholder="Company Name"
              />
            </div>

            {error && <div className="status-message error">{error}</div>}

            <button type="submit" className="action-btn" disabled={loading}>
              {loading ? "Creating Account..." : "Register Now"} <FaArrowRight />
            </button>
          </form>

          <div className="panel-footer">
            <p>Already a member? <a href="/login" className="highlight-link">Sign In</a></p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Registration;
